import React from "react";
import "../css/Pages.css";

const Menu = () => {
  return (
    <div className="page menu-page">
      <h1 className="page-title">Our Menu</h1>
      <p className="page-intro">
        Explore our wide range of delicious dishes, crafted with fresh ingredients and love. 
        From starters to desserts, every dish promises flavor and satisfaction.
      </p>

      {/* Starters */}
      <section className="menu-section">
        <h2 className="section-title">Starters</h2>
        <div className="menu-grid">
          <div className="menu-card">
            <img src="https://images.pexels.com/photos/7363744/pexels-photo-7363744.jpeg" alt="Spring Rolls" />
            <h4>Spring Rolls</h4>
            <p>Crispy rolls filled with fresh vegetables and herbs.</p>
          </div>
          <div className="menu-card">
            <img src="https://images.pexels.com/photos/4210858/pexels-photo-4210858.jpeg" alt="Bruschetta" />
            <h4>Bruschetta</h4>
            <p>Toasted bread topped with fresh tomatoes, basil, and olive oil.</p>
          </div>
          <div className="menu-card">
            <img src="https://images.unsplash.com/photo-1546069901-ba9599a7e63c" alt="Stuffed Mushrooms" />
            <h4>Stuffed Mushrooms</h4>
            <p>Soft mushrooms stuffed with cheese and herbs, baked to perfection.</p>
          </div>
           <div className="menu-card">
            <img src="https://images.pexels.com/photos/7745368/pexels-photo-7745368.jpeg" alt="Spring Rolls" />
            <h4>Momo Rolls</h4>
            <p>Crispy rolls filled with fresh vegetables and herbs.</p>
          </div>
          <div className="menu-card">
            <img src="https://images.pexels.com/photos/6608541/pexels-photo-6608541.jpeg" alt="Bruschetta" />
            <h4>Toasted bread </h4>
            <p>Toasted bread topped with fresh tomatoes, basil, and olive oil.</p>
          </div>
          
        </div>
      </section>

      {/* Main Course */}
      <section className="menu-section">
        <h2 className="section-title">Main Course</h2>
        <div className="menu-grid">
          <div className="menu-card">
            <img src="https://images.pexels.com/photos/32872596/pexels-photo-32872596.jpeg" alt="Margherita Pizza" />
            <h4>Margherita Pizza</h4>
            <p>Classic pizza with tomato sauce, mozzarella, and fresh basil.</p>
          </div>
          <div className="menu-card">
            <img src="https://images.pexels.com/photos/5865440/pexels-photo-5865440.jpeg" alt="Cheesy Burger" />
            <h4>Cheesy Burger</h4>
            <p>Juicy veggie patty with melted cheese, lettuce, and tomato.</p>
          </div>
          <div className="menu-card">
            <img src="https://images.pexels.com/photos/2703468/pexels-photo-2703468.jpeg" alt="Pasta Alfredo" />
            <h4>Pasta Alfredo</h4>
            <p>Creamy pasta with garlic, herbs, and parmesan cheese.</p>
          </div>
          <div className="menu-card">
            <img src="https://images.pexels.com/photos/24513648/pexels-photo-24513648.png" alt="Cheesy Burger" />
            <h4>Roll chips</h4>
            <p>Juicy veggie patty with melted cheese, lettuce, and tomato.</p>
          </div>
        </div>
      </section>

      {/* Desserts */}
      <section className="menu-section">
        <h2 className="section-title">Desserts</h2>
        <div className="menu-grid">
          <div className="menu-card">
            <img src="https://images.unsplash.com/photo-1578985545062-69928b1d9587" alt="Chocolate Cake" />
            <h4>Chocolate Cake</h4>
            <p>Rich, moist chocolate cake topped with ganache.</p>
          </div>
          <div className="menu-card">
            <img src="https://images.pexels.com/photos/11581120/pexels-photo-11581120.jpeg" alt="Fruit Tart" />
            <h4>Fruit Tart</h4>
            <p>Buttery tart filled with custard and topped with fresh fruits.</p>
          </div>
          <div className="menu-card">
            <img src="https://images.pexels.com/photos/29851693/pexels-photo-29851693.jpeg" alt="Ice Cream Sundae" />
            <h4>Ice Cream Sundae</h4>
            <p>Creamy ice cream topped with chocolate sauce, nuts, and cherry.</p>
          </div>
        </div>
      </section>

      {/* Beverages */}
      <section className="menu-section">
        <h2 className="section-title">Beverages</h2>
        <div className="menu-grid">
          <div className="menu-card">
            <img src="https://images.pexels.com/photos/2109099/pexels-photo-2109099.jpeg" alt="Fresh Juice" />
            <h4>Fresh Juice</h4>
            <p>Refreshing juice made from seasonal fruits.</p>
          </div>
          <div className="menu-card">
            <img src="https://images.unsplash.com/photo-1509042239860-f550ce710b93" alt="Coffee" />
            <h4>Specialty Coffee</h4>
            <p>Rich coffee brewed to perfection with aromatic flavors.</p>
          </div>
          <div className="menu-card">
            <img src="https://images.pexels.com/photos/17574117/pexels-photo-17574117.jpeg" alt="Mocktails" />
            <h4>Mocktails</h4>
            <p>Refreshing non-alcoholic beverages to quench your thirst.</p>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Menu;
